import React from 'react';
import { FadeIn } from './FadeIn';
export function WhyWomenDont() {
  return <section className="bg-cream-100 py-12 md:py-16" data-id="element-287">
      <div className="max-w-3xl mx-auto px-6" data-id="element-288">
        <FadeIn data-id="element-289">
          <h2 className="text-3xl md:text-4xl mb-10 text-center" data-id="element-290">
            Why Most Women Don't Negotiate
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6 text-center" data-id="element-291">
            {['Intimidating', 'Confusing', 'Confrontational'].map((word, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-cream-200" data-id="element-292">
                <span className="text-lg font-medium text-brown-800" data-id="element-293">
                  {word}.
                </span>
              </div>)}
          </div>

          <div className="space-y-2 text-base text-brown-700 text-center max-w-xl mx-auto mb-6" data-id="element-294">
            <p data-id="element-295">
              So you adjust the budget instead. You dip into savings. You pay
              it.
            </p>
            <p data-id="element-296">And you hope that's the last surprise.</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-297">
          <div className="bg-brown-900 text-cream-50 p-8 md:p-12 rounded-2xl text-center relative overflow-hidden" data-id="element-298">
            <div className="relative z-10" data-id="element-299">
              <p className="text-terracotta-400 font-medium mb-4 uppercase tracking-wider text-sm" data-id="element-300">
                But here's what happens without a system
              </p>
              <h3 className="text-2xl md:text-3xl font-bold mb-6 leading-tight text-[#FAF6F1]" data-id="element-301">
                Most people negotiate with feelings.
                <br data-id="element-302" />
                Hospitals negotiate with systems.
                <br data-id="element-303" />
                <span className="text-terracotta-400" data-id="element-304">
                  Systems beat feelings—unless you've got one of your own.
                </span>
              </h3>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}